import React, { useContext, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { Card } from 'types';
import styles from './../ContentStyles.module.css';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import classNames from 'classnames';
import { GuideContext } from 'components/Guide';
import { AppContext } from 'providers';
export interface VideoContentProps {
  content: Card;
  controls?: boolean;
  isMobile?: boolean;
}
export const VideoContent: React.FC<VideoContentProps> = ({
  content,
  controls = false,
  isMobile
}) => {
  const {
    setCanGoNext
  } = useContext(GuideContext);
  const {
    setToast
  } = useContext(AppContext);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [videoEnded, setVideoEnded] = useState<boolean>(false);
  const playerRef = useRef<ReactPlayer>(null);
  const videoCardContentClasses = classNames(styles.videoCardContent, {
    [styles.videoCardMobile]: isMobile
  });
  const handleClickPreview = (e: React.MouseEvent<HTMLButtonElement> | React.TouchEvent<HTMLButtonElement>) => {
    e.stopPropagation(); // Prevent navigation when clicking on the video
    setIsPlaying(true);
  };
  const showVideoWarning = isMobile && !videoEnded;
  if (!content.mediaUrl) return null;
  return <>
      <div className={videoCardContentClasses}>
        <ReactPlayer ref={playerRef} url={content.mediaUrl} playing={isPlaying} controls={controls} width="100%" height="100%" light onClickPreview={handleClickPreview} onEnded={() => {
        setVideoEnded(true);
        setCanGoNext(true);
        setIsPlaying(false);
      }} onError={() => {
        setToast({
          title: 'There was an error playing the video',
          description: 'Navigation has been enabled. Please contact your administrator if this issue persists.',
          status: 'error'
        });
        setCanGoNext(true);
      }} playIcon={<button className={styles.playButton} aria-label="Play video" onClick={() => setIsPlaying(true)}>
              <ICON_BY_NAME.play width="24px" height="24px" marginLeft="6px" />
            </button>} data-sentry-element="ReactPlayer" data-sentry-source-file="VideoContent.tsx" />
      </div>
      {showVideoWarning && <div className={styles.videoCardMobileText}>
          <p>Please watch the video to continue</p>
        </div>}
    </>;
};
export default VideoContent;